const INTAKE_PAGE_SLUGS: Record<string, string> = {
  K1: 'key-questions',
  F1: 'what-we-need',
  M1: 'clinic-documents',
  M2: 'practice-identity',
  M3: 'addresses-contacts',
  M4: 'payers',
  M5: 'provider-roster',
  M6: 'clinic-review',
  P1: 'your-documents',
  P2: 'your-identifiers',
  P3: 'licenses-states',
  P4: 'malpractice',
  P5: 'about-you',
  P6: 'your-review',
  X1: 'confirm-completion',
};

const INTAKE_SLUG_PAGE_KEYS = new Map(
  Object.entries(INTAKE_PAGE_SLUGS).map(([pageKey, slug]) => [slug, pageKey]),
);

export function intakePagePath(pageKey: string): string {
  return `/intake/${INTAKE_PAGE_SLUGS[pageKey] ?? INTAKE_PAGE_SLUGS.K1}`;
}

export function resolveIntakePageKey(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean);
  const intakeIndex = parts.lastIndexOf('intake');
  const slug = intakeIndex >= 0 ? parts[intakeIndex + 1] : undefined;
  return slug ? (INTAKE_SLUG_PAGE_KEYS.get(slug) ?? null) : null;
}

export function hasIntakeV2DevelopmentOverride(search: string): boolean {
  return import.meta.env.DEV && new URLSearchParams(search).get('v2') === '1';
}
